import { createContext, useContext } from 'react';
import type { HostSlotLoader } from './loader';

const HostSlotLoaderContext = createContext<HostSlotLoader | null>(null);

/** Hosts that can fill `platform.hostSlot` placements mount this provider. */
export const HostSlotLoaderProvider = HostSlotLoaderContext.Provider;

/** `null` when the host supplies no loader; the slot then keeps its fallback. */
export function useHostSlotLoader(): HostSlotLoader | null {
  return useContext(HostSlotLoaderContext);
}
